import { makeStyles } from "@material-ui/styles";
import { TH_ICON_STYLING } from "../../../../styles/constants";

export default makeStyles(theme => ({
  thIcon: { ...TH_ICON_STYLING },
  faIcon: { color: theme.palette.secondary.main, fontSize: 14, marginLeft: 4 },
}));
